import type { JSX } from 'react';

/**
 * Shown while a code-split route module is still downloading. It is a live
 * region so the wait is announced rather than being a silent blank screen.
 */
export function RouteFallback(): JSX.Element {
  return (
    <div className="flex min-h-dvh items-center justify-center px-6">
      <p role="status" aria-live="polite" className="text-sm text-muted">
        Loading…
      </p>
    </div>
  );
}
